import {
  updateTourItemsThroughNormalFlow,
  updateTourProgress,
} from '../tour/firebase-controller';
import {
  getActiveChecklistItemIndex,
  getActiveTourTooltipIndex,
  getTourDataFromFirbase,
  updateActiveChecklistItemIndex,
  updateActiveChecklistItemIndexDB,
  updateActiveTourTooltipIndex,
} from './../tour/slice';
import {
  createListFiltersData,
  mapDataToInputItems,
  mapDataToInputItemsFromAppliedFilter,
} from '../filter/helpers';
import {
  addListInputItems,
  getAppliedFilters,
  getMobileAppliedFilterByScreen,
  updateMobileFiltersByScreen,
  updateSiftByScreen,
} from '../filter/slice';
import {
  InputItem,
  ListFilterInput,
  ListFilterKeys,
  ListInputItemOptions,
  Mappings,
  MobileSiftScreen,
  SiftScreenEnum,
} from '../filter/model';
import _ from 'lodash';
import { Api } from '../api';
import {
  CreateCampaignRequest,
  CreateCampaignResponse,
  CampaignListRequest,
  CampaignListResponse,
  CampaignRequest,
  CampaignResponse,
  UpdateCampaignRequest,
  CampaignDetailsResponse,
  CampaignDetailsRequest,
  CampaignCustomersResponse,
  CampaignCustomersRequest,
  CampaignProductsResponse,
  CampaignProductsRequest,
  RemoveProductFromCampaigntResponse,
  RemoveProductFromCampaignRequest,
  RemoveCustomerFromCampaigntResponse,
  RemoveCustomerProductFromCampaignRequest,
  CampaignDetailsV2Response,
  CampaignDetailsV2Request,
  CampaignFiltersResponse,
  CampaignFiltersRequest,
  PublishCampaignResponse,
  PublishCampaignRequest,
  CampaignCustomerUploadResponse,
  CampaignCustomerUploadRequest,
  CampaignCustomerReportDownloadRequest,
  CampaignRevenueResponse,
  CampaignRevenueRequest,
  CampaignReportResponse,
  CampaignReportRequest,
  CreateTrialCampaignResponse,
  CreateTrialCampaignRequest,
  CampaignAudienceResponse,
  CampaignAudienceRequest,
  CampaignAttemptsResponse,
  CampaignAttemptsRequest,
  DeleteCampaignAudienceResponse,
  DeleteCampaignAudienceRequest,
  DeleteCamapaignTeamMemberResponse,
  DeleteCampaignTeamMemberRequest,
  DeleteBotFromCampaignResponse,
  DeleteBotFromCampaignRequest,
  RemoveAllProductFromCampaignRequest,
  CampaignTeamMembersResponse,
  CampaignTeamMembersRequest,
  CustomerStatsResponse,
  CustomerStatsRequest,
} from './model';
import { isWeb, isNative } from '@zonofi/common';
import { getIsTourActive } from '../tour';
import { RootState } from '../root/root-types';

export const campaginsApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    createCampaign: builder.mutation<
      CreateCampaignResponse,
      CreateCampaignRequest
    >({
      query({ workspaceId, sellerWorkspaceId, body }) {
        return {
          url: `hub/commerce-v2/campaigns/${workspaceId}`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: body,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        queryFulfilled.then((response) => {
          const statusArray = [
            { id: '0', name: 'Published' },
            { id: '1', name: 'Not Published' },
          ];
          const statusList = mapDataToInputItems(
            statusArray,
            'id',
            'name'
          ).filter((x: any) => x.value);

          dispatch(
            addListInputItems({
              inputItems: statusList,
              key: ListInputItemOptions.campaignStatus,
            })
          );

          if (
            request.body.get('sendNow') &&
            response?.data?.statusCode === 201
          ) {
            const state = getState() as RootState;
            if (getIsTourActive(state)) {
              if (getActiveTourTooltipIndex(state) === 10) {
                dispatch(
                  updateActiveTourTooltipIndex(
                    getActiveTourTooltipIndex(state) + 1
                  )
                );
                const checklistItemId = getTourDataFromFirbase(state)?.find(
                  (item) => item?.order === getActiveChecklistItemIndex(state)
                )?.id;
                if (checklistItemId) updateTourProgress(checklistItemId);
              }
            } else {
              updateTourItemsThroughNormalFlow(
                false,
                getTourDataFromFirbase(state),
                9
              );
            }
          }
        });
      },
      transformResponse: (
        createResponse: CreateCampaignResponse,
        meta,
        arg
      ) => {
        if (!isWeb()) {
          const startDate = arg?.body?.get('startDate');

          return {
            ...createResponse,
            isScheduled: !_.isNull(startDate) ? true : false,
          };
        } else {
          return createResponse;
        }
      },
    }),
    deleteCampaign: builder.mutation<any, any>({
      query(args) {
        return {
          url: `hub/commerce-v2/campaigns/${args?.workspaceId}/${args?.campaignId}`,
          method: 'DELETE',
          params: {
            sellerWorkspaceId: args?.workspaceId,
          },
        };
      },
    }),
    getAllCampaigns: builder.mutation<
      CampaignListResponse,
      CampaignListRequest
    >({
      query({ workspaceId, sellerWorkspaceId, body, params }) {
        return {
          url: `hub/commerce-v2/campaigns/list/${workspaceId}`,
          method: 'POST',
          params: { ...params, sellerWorkspaceId, random: Math.random() },
          body,
        };
      },
    }),
    getCampaignById: builder.query<CampaignResponse, CampaignRequest>({
      query({ workspaceId, campaignId, sellerWorkspaceId, customerId }) {
        return {
          url: `hub/commerce-v2/campaigns/${workspaceId}/${campaignId}`,
          method: 'GET',
          params: { sellerWorkspaceId, customerId, random: Math.random() },
        };
      },
    }),
    updateCampaign: builder.mutation<CampaignResponse, UpdateCampaignRequest>({
      query({ workspaceId, campaignId, sellerWorkspaceId, body }) {
        return {
          url: `hub/commerce-v2/campaigns/${workspaceId}/${campaignId}`,
          method: 'PUT',
          params: { sellerWorkspaceId },
          body: body,
        };
      },
    }),
    getCampaignDetails: builder.query<
      CampaignDetailsResponse,
      CampaignDetailsRequest
    >({
      query(args) {
        return {
          url: `/hub/commerce-v2/campaigns/details/${args?.workspaceId}`,
          method: 'GET',
          params: { ...args, random: Math.random() },
        };
      },
    }),
    getCampaignCustomers: builder.query<
      CampaignCustomersResponse,
      CampaignCustomersRequest
    >({
      query({ workspaceId, ...params }) {
        return {
          url: `/hub/commerce-v2/campaigns/customers/${workspaceId}`,
          method: 'GET',
          params: { ...params, random: Math.random() },
        };
      },
    }),

    getCampaignProducts: builder.mutation<
      CampaignProductsResponse,
      CampaignProductsRequest
    >({
      query({ workspaceId, sellerWorkspaceId, ...body }) {
        return {
          url: `/hub/commerce-v2/campaigns/products/${workspaceId}`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: body,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        dispatch(
          updateMobileFiltersByScreen({
            screen: MobileSiftScreen.CAMPAIGN_PRODUCTS,
            filter: {},
            loading: true,
          })
        );

        queryFulfilled
          .then((response) => {
            const { data } = response;

            if (isNative()) {
              const appliedList = getMobileAppliedFilterByScreen(
                MobileSiftScreen.CAMPAIGN_PRODUCTS
              )(getState() as any)?.listFilter;

              const categoryCodes =
                data?.data?.categoryCodes?.map((item) => ({
                  id: item?.categoryCode,
                  value: item?.categoryName,
                  selected: false,
                })) ?? [];

              const divisionCodes =
                data?.data?.divisionSummary?.map((item) => ({
                  id: item?.divisionCode,
                  value: item?.name,
                  selected: false,
                })) ?? [];

              const listFilter: Partial<ListFilterInput> = {
                [ListFilterKeys.Category]: {
                  multiSelect: false,
                  value: categoryCodes,
                },
                [ListFilterKeys.Division]: {
                  multiSelect: true,
                  value: divisionCodes,
                },
              };

              Object.entries(appliedList || {}).forEach(([key, value]) => {
                const filterKey = key as ListFilterKeys;
                if (listFilter[filterKey]) {
                  const data = listFilter[filterKey].value;
                  value.forEach(({ id }) => {
                    const index = data.findIndex((x) => x.id === id);
                    if (index !== -1) {
                      data[index].selected = true;
                      const defaultIndex = data.findIndex((x) => x.isDefault);
                      if (defaultIndex !== -1 && defaultIndex !== index) {
                        data[defaultIndex].selected = false;
                      }
                    }
                  });
                  listFilter[filterKey].value = data;
                }
              });

              dispatch(
                updateMobileFiltersByScreen({
                  screen: MobileSiftScreen.CAMPAIGN_PRODUCTS,
                  filter: { listFilter },
                  loading: false,
                })
              );
            }
          })
          .finally(() => {
            dispatch(
              updateMobileFiltersByScreen({
                screen: MobileSiftScreen.CAMPAIGN_PRODUCTS,
                filter: {},
                loading: false,
              })
            );
          });
      },
    }),

    getCampaignTeamMembers: builder.mutation<
      CampaignTeamMembersResponse,
      CampaignTeamMembersRequest
    >({
      query({ params, body }) {
        return {
          url: `/hub/commerce-v2/campaigns/team-members/details/${params?.sellerWorkspaceId}`,
          params: { sellerWorkspaceId: params?.sellerWorkspaceId },
          method: 'POST',
          body: body,
        };
      },
    }),

    getCampaignDetailsV2: builder.query<
      CampaignDetailsV2Response,
      CampaignDetailsV2Request
    >({
      query: (args) => {
        return {
          url: `hub/commerce-v2/campaigns/details/customer/${args?.workspaceId}`,
          params: { ...args?.params, random: Math.random() },
          method: 'GET',
        };
      },
    }),
    removeProductFromCampaign: builder.mutation<
      RemoveProductFromCampaigntResponse,
      RemoveProductFromCampaignRequest
    >({
      query({ productVariantIds, ...params }) {
        return {
          url: `/hub/commerce-v2/campaigns/products`,
          method: 'DELETE',
          params: params,
          body: { productVariantIds },
        };
      },
    }),
    removeAllProductFromCampaign: builder.mutation<
      RemoveProductFromCampaigntResponse,
      RemoveAllProductFromCampaignRequest
    >({
      query({ body, ...params }) {
        return {
          url: `/hub/commerce-v2/campaigns/products/${params?.sellerWorkspaceId}/${params?.campaignId}`,
          method: 'DELETE',
          params: params,
          body: body,
        };
      },
    }),
    removeCustomerFromCampaign: builder.mutation<
      RemoveCustomerFromCampaigntResponse,
      RemoveCustomerProductFromCampaignRequest
    >({
      query({ customerIds, ...params }) {
        return {
          url: `/hub/commerce-v2/campaigns/customers`,
          method: 'DELETE',
          params: { ...params, random: Math.random() },
          body: { customerIds, workspaceId: params.sellerWorkspaceId },
        };
      },
    }),

    publishCampaign: builder.mutation<
      PublishCampaignResponse,
      PublishCampaignRequest
    >({
      query({ workspaceId, sellerWorkspaceId, body }) {
        return {
          url: `/hub/commerce-v2/campaigns/publish/${workspaceId}`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: body,
        };
      },
      onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        queryFulfilled.then((response) => {
          if (response?.data) {
            const state = getState() as RootState;
            if (getIsTourActive(state)) {
              if (getActiveTourTooltipIndex(state) === 13) {
                dispatch(updateActiveTourTooltipIndex(11));
                const checklistItemId = getTourDataFromFirbase(state)?.find(
                  (item) => item?.order === getActiveChecklistItemIndex(state)
                )?.id;
                if (checklistItemId) updateTourProgress(checklistItemId);
              }
            } else {
              updateTourItemsThroughNormalFlow(
                false,
                getTourDataFromFirbase(state),
                8
              );
            }
            dispatch(updateActiveChecklistItemIndex(8));
            dispatch(updateActiveChecklistItemIndexDB(8));
          }
        });
      },
    }),
    getCampaignFilters: builder.query<
      CampaignFiltersResponse,
      CampaignFiltersRequest
    >({
      query({ workspaceId, ...params }) {
        return {
          url: `/hub/commerce-v2/campaigns/filter/${workspaceId}`,
          method: 'GET',
          params: params,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        queryFulfilled.then((response) => {
          const { data } = response;
          if (isWeb()) {
            const statusArray =
              data?.status?.map((status) => ({
                id: status,
                name: status,
                eitherOr: true,
                selected: false,
              })) ?? [];
            const imagePreviewArray = data?.imagePreview?.map(
              (imagePreview) => ({
                id: imagePreview,
                name:
                  imagePreview === 'LIST'
                    ? 'One Frame'
                    : imagePreview === 'CUSTOM'
                      ? 'Custom'
                      : 'Carousel',
                eitherOr: true,
                selected: false,
              })
            );
            const audienceTypeArray = data?.audienceType?.map((type) => ({
              id: type,
              name: type,
              eitherOr: true,
              selected: false,
            }));
            const botTypeArray = data?.bots?.map((type) => ({
              id: type?.id,
              name: type?.name,
              eitherOr: true,
              selected: false,
            }));
            const adSourceArray = data?.adSource?.map((type) => ({
              id: type,
              name: type,
              eitherOr: true,
              selected: false,
            }));

            const statusList = mapDataToInputItems(
              statusArray,
              'id',
              'name',
              'false'
            )?.filter((x: any) => x.value);

            const imagePreviewList = mapDataToInputItems(
              imagePreviewArray,
              'id',
              'name',
              'false'
            )?.filter((x: any) => x?.value);

            const audienceTypeList = mapDataToInputItems(
              audienceTypeArray,
              'id',
              'name',
              'false',
              true
            )?.filter((x: any) => x?.value);

            const botTypeList = mapDataToInputItems(
              botTypeArray,
              'id',
              'name',
              'false'
            ).filter((x: any) => x.value);

            const adSourceList = mapDataToInputItems(
              adSourceArray,
              'id',
              'name',
              'false',
              true
            )?.filter((x: any) => x?.value);
            // dispatch(
            //   addListInputItems({
            //     inputItems: botTypeArray,
            //     key: ListInputItemOptions.botTypeList,
            //   })
            // );

            dispatch(
              updateSiftByScreen({
                screen: SiftScreenEnum.CAMPAIGN_LIST_SCREEN,
                filters: {
                  campaignStatus: statusList,
                  imagePreview: imagePreviewList,
                  audienceType: audienceTypeList,
                  adSource: adSourceList,
                  botTypeList: botTypeList,
                },
              })
            );
            dispatch(
              updateSiftByScreen({
                screen: SiftScreenEnum.SEND_CAMPAIGN_SCREEN,
                filters: {
                  campaignStatus: statusList,
                  imagePreview: imagePreviewList,
                  audienceType: audienceTypeList,
                  adSource: adSourceList,
                  botTypeList: botTypeList,
                },
              })
            );
          } else {
            const mappings: Mappings<CampaignFiltersResponse>[] = [
              {
                dataKey: 'imagePreview',
                idKey: '',
                valueKey: '',
                filterKey: ListFilterKeys.CampaignMode,
                updateValues: true,
              },
              {
                dataKey: 'status',
                idKey: '',
                valueKey: '',
                filterKey: ListFilterKeys.CampaignByStatus,
              },
              {
                dataKey: 'audienceType',
                idKey: '',
                valueKey: '',
                filterKey: ListFilterKeys.CampaignType,
              },
            ];
            const listFilter = createListFiltersData(data, mappings);
            dispatch(
              updateMobileFiltersByScreen({
                screen: MobileSiftScreen.CAMPAIGNS,
                filter: { listFilter },
              })
            );
          }
        });
      },
    }),

    CampaignCustomerUpload: builder.mutation<
      CampaignCustomerUploadResponse,
      CampaignCustomerUploadRequest
    >({
      query({ workspaceId, sellerWorkspaceId, body }) {
        return {
          url: `/hub/commerce-v2/campaigns/details/customers/upload/${workspaceId}`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: body,
        };
      },
    }),

    CampaignCustomerReportDownload: builder.mutation<
      string,
      CampaignCustomerReportDownloadRequest
    >({
      query({ sellerWorkspaceId, campaignId, attemptId, filters }) {
        return {
          url: `/hub/reports/api/v1/analytics/download`,
          method: 'POST',
          params: { sellerWorkspaceId },
          body: {
            view: 'campaign_customer',
            format: 'xlsx',
            campaignId,
            attemptId,
            campaign_filters: filters ?? {},
            metrics: [
              'customerFirmName',
              'customerCode',
              'mobileNumber',
              'segments',
              'routes',
              'sent',
              'impressions',
              'engaged',
              'ordered',
              'errorDescription',
            ],
          },
          responseHandler: (response) => response.blob(),
        };
      },
    }),

    getRevenueReport: builder.mutation<
      CampaignRevenueResponse,
      CampaignRevenueRequest
    >({
      query: (args) => {
        return {
          url: `/hub/reports/api/v2/campaign/revenue-report`,
          method: 'POST',
          body: args,
        };
      },
    }),

    getCampaignReport: builder.mutation<
      CampaignReportResponse,
      CampaignReportRequest
    >({
      query: (args) => {
        return {
          url: `/hub/reports/api/v2/revenue-by-source`,
          method: 'POST',
          body: args,
        };
      },
    }),
    createTrialCampaign: builder.mutation<
      CreateTrialCampaignResponse,
      CreateTrialCampaignRequest
    >({
      query: (args) => {
        return {
          url: `hub/commerce-v2/campaigns/trial/${args.params.sellerWorkspaceId}`,
          method: 'POST',
          params: args.params,
        };
      },
    }),
    getCampaignAudience: builder.query<
      CampaignAudienceResponse,
      CampaignAudienceRequest
    >({
      query: (args) => {
        return {
          url: `/hub/commerce-v2/campaigns/audience/${args.workspaceId}`,
          method: 'GET',
          params: args,
        };
      },
    }),
    getCampaignAttempts: builder.query<
      CampaignAttemptsResponse,
      CampaignAttemptsRequest
    >({
      query: (args) => {
        const {
          campaignStatusList,
          dynamicSegmentsList,
          routesList,
          segmentsList,
          ...otherParams
        } = args;

        const params = new URLSearchParams();

        Object.entries(otherParams).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            params.append(key, String(value));
          }
        });

        campaignStatusList?.forEach((status) => {
          params.append('campaignStatus[]', status);
        });

        dynamicSegmentsList?.forEach((id) => {
          params.append('dynamicSegmentIds[]', String(id));
        });

        routesList?.forEach((id) => {
          params.append('routeIds[]', String(id));
        });

        segmentsList?.forEach((id) => {
          params.append('segmentIds[]', String(id));
        });

        return {
          url: `/hub/commerce-v2/campaigns/attempt/${args.workspaceId}`,
          method: 'GET',
          params,
        };
      },
      async onQueryStarted(request, { dispatch, queryFulfilled, getState }) {
        queryFulfilled.then((response) => {
          const { data } = response;
          if (isWeb()) {
            const state = getState() as RootState;
            const appliedFilters = getAppliedFilters(state);

            const campaignStatusArray =
              data?.data?.filters?.campaignStatus.map((status) => ({
                id: status.key,
                name: status.formattedKey,
                selected: false,
              })) ?? [];

            const dynamicSegmentsArray =
              data?.data?.filters?.dynamicSegments.map((dynamic) => ({
                id: dynamic.id,
                name: dynamic.name,
                selected: false,
              }));

            const routesArray = data?.data?.filters?.routes?.map((route) => ({
              id: route?.id,
              name: route?.name,
              selected: false,
            }));

            const segmentsArray = data?.data?.filters?.segments?.map(
              (segment) => ({
                id: segment?.id,
                name: segment?.name,
                selected: false,
              })
            );

            const campaignStatus = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              campaignStatusArray,
              'id',
              'name',
              ListInputItemOptions.campaignStatus
            )?.filter((x: any) => x.value);

            const dynamicSegments = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              dynamicSegmentsArray,
              'id',
              'name',
              ListInputItemOptions.dynamicSegments
            )?.filter((x: any) => x.value);

            const routes = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              routesArray,
              'id',
              'name',
              ListInputItemOptions.routes
            )?.filter((x: any) => x.value);

            const segments = mapDataToInputItemsFromAppliedFilter(
              appliedFilters,
              segmentsArray,
              'id',
              'name',
              ListInputItemOptions.segments
            )?.filter((x: any) => x.value);

            dispatch(
              updateSiftByScreen({
                screen: SiftScreenEnum.CAMPAIGN_ATTEMPTS,
                filters: {
                  campaignStatus,
                  dynamicSegments,
                  routes,
                  segments,
                },
              })
            );
          } else {
            const appliedList = getMobileAppliedFilterByScreen(
              MobileSiftScreen.CAMPAIGN_CUSTOMERS_STATS
            )(getState() as any)?.listFilter;

            const campaignStatus: InputItem[] =
              data?.data?.filters?.campaignStatus.map((status) => ({
                id: status.key,
                value: status.formattedKey,
                selected: false,
              })) ?? [];

            const listFilter: Partial<ListFilterInput> = {
              [ListFilterKeys.CampaignStatus]: {
                multiSelect: false,
                value: campaignStatus,
              },
            };

            Object.entries(appliedList || {}).forEach(([key, value]) => {
              const filterKey = key as ListFilterKeys;
              if (listFilter[filterKey]) {
                const data = listFilter[filterKey].value;
                value.forEach(({ id }) => {
                  const index = data.findIndex((x) => x.id === id);
                  if (index !== -1) {
                    data[index].selected = true;
                    const defaultIndex = data.findIndex((x) => x.isDefault);
                    if (defaultIndex !== -1 && defaultIndex !== index) {
                      data[defaultIndex].selected = false;
                    }
                  }
                });
                listFilter[filterKey].value = data;
              }
            });

            dispatch(
              updateMobileFiltersByScreen({
                screen: MobileSiftScreen.CAMPAIGN_CUSTOMERS_STATS,
                filter: { listFilter },
                loading: false,
              })
            );
          }
        });
      },
    }),
    deleteCampaignAudience: builder.mutation<
      DeleteCampaignAudienceResponse,
      DeleteCampaignAudienceRequest
    >({
      query: (args) => {
        return {
          url: `/hub/commerce-v2/campaigns/audience/${args.workspaceId}/${args.campaignId}`,
          method: 'DELETE',
          params: { sellerWorkspaceId: args.workspaceId },
          body: args.body,
        };
      },
    }),

    deleteCampaignTeamMember: builder.mutation<
      DeleteCamapaignTeamMemberResponse,
      DeleteCampaignTeamMemberRequest
    >({
      query: (args) => {
        return {
          url: `/hub/commerce-v2/campaigns/team-member/${args.workspaceId}/${args.campaignId}`,
          method: 'DELETE',
          params: { sellerWorkspaceId: args.workspaceId },
          body: args.body,
        };
      },
    }),

    deleteBotFromCampaign: builder.mutation<
      DeleteBotFromCampaignResponse,
      DeleteBotFromCampaignRequest
    >({
      query: (args) => {
        return {
          url: `/hub/commerce-v2/campaigns/unassign-bots/${args.sellerWorkspaceId}`,
          method: 'POST',
          params: { sellerWorkspaceId: args.sellerWorkspaceId },
          body: args.body,
        };
      },
    }),
    getCustomerStats: builder.query<
      CustomerStatsResponse,
      CustomerStatsRequest
    >({
      query: (args) => {
        return {
          url: `hub/commerce-v2/campaigns/blocks/${args?.blockId}/customers/${args?.attemptId}`,
          method: 'GET',
          params: args.params,
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useCreateCampaignMutation,
  useGetAllCampaignsMutation,
  useLazyGetCampaignByIdQuery,
  useUpdateCampaignMutation,
  useLazyGetCampaignDetailsQuery,
  useLazyGetCampaignCustomersQuery,
  useLazyGetCampaignDetailsV2Query,
  useRemoveCustomerFromCampaignMutation,
  useRemoveProductFromCampaignMutation,
  useGetCampaignProductsMutation,
  useLazyGetCampaignFiltersQuery,
  usePublishCampaignMutation,
  useCampaignCustomerUploadMutation,
  useCampaignCustomerReportDownloadMutation,
  useGetRevenueReportMutation,
  useGetCampaignReportMutation,
  useDeleteCampaignMutation,
  useCreateTrialCampaignMutation,
  useLazyGetCampaignAudienceQuery,
  useLazyGetCampaignAttemptsQuery,
  useDeleteCampaignAudienceMutation,
  useDeleteCampaignTeamMemberMutation,
  useDeleteBotFromCampaignMutation,
  useRemoveAllProductFromCampaignMutation,
  useGetCampaignTeamMembersMutation,
  useLazyGetCustomerStatsQuery,
} = campaginsApi;
